import { initialPagination, initialState, makeListEffects, makeListReducers } from '@/models/utils';
import { filtersConfig } from './utils';
import { bindServices } from '@/services/api';
import { CoreEnums } from '@/utils/domain/constants';

const api = bindServices('shortenedUrls');
const namespace = 'shortenedUrls';

const ShortenedUrlsModel = {
  namespace,
  state: {
    ...initialState,
    orderBy: 'created desc',
    filtersConfig,
    list: [],
  },

  effects: {
    ...makeListEffects({
      namespace,
      fetchRoute: 'shortenedUrl',
      fetchParams: 'ShortenedUrl',
    }),
    *openDrawerView({ payload }, { put }) {
      yield put({
        type: 'openDrawerViewReducer',
        payload,
      });
    },
    *fetchItemSelected({ payload }, { put }) {
      try {
        yield put({
          type: 'queryItemSelectedShortenedUrl',
          payload: {
            ...payload,
          },
        });
      } catch (error) {
        yield put({
          type: 'closeDrawerViewReducer',
          payload: {
            state: false,
          },
        });
      }
    },
    *closeDrawerView({ payload }, { put }) {
      yield put({
        type: 'closeDrawerViewReducer',
        payload,
      });
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        const [id, isActiveStr] = params.split('/');
        const isActive = isActiveStr === 'true' || isActiveStr === true;
        yield call(api.exec, {
          route: `shortenedUrl/activate/${id}/${isActive}`,
          httpMethod: 'post',
          data: {},
        });
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {}
    },
    *bulkToggleActive({ payload }, { call, put }) {
      try {
        const { BulkActionType } = CoreEnums;
        const { ids, isActive } = payload;
        const bulkActionType = isActive ? BulkActionType.Activate : BulkActionType.Deactivate;

        yield call(api.bulkAction, {
          route: 'shortenedUrl',
          bulkActionType,
          ids,
        });
        yield put({
          type: 'bulkShortenedUrlActive',
          payload: { ids, state: isActive },
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
          });
        }
      }
    },
    *bulkActivateShortenedUrls({ payload }, { put }) {
      yield put({
        type: 'bulkToggleActive',
        payload: { ...payload, isActive: true },
      });
    },
    *bulkDeactivateShortenedUrls({ payload }, { put }) {
      yield put({
        type: 'bulkToggleActive',
        payload: { ...payload, isActive: false },
      });
    },
  },

  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: {
        ...initialState,
        filtersConfig,
      },
    }),

    openDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: payload.id,
        openView: payload.state,
        item: {},
        view: true,
      };
    },
    queryItemSelectedShortenedUrl(state, { payload }) {
      const item = state.list.find((item) => item.id === payload.id);
      return {
        ...state,
        item: item,
        id: payload.id,
      };
    },
    closeDrawerViewReducer(state, { payload }) {
      return {
        ...state,
        id: null,
        openView: payload.state,
        item: null,
        view: false,
      };
    },
    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));
      return {
        ...state,
        list,
      };
    },
    bulkShortenedUrlActive(state, { payload }) {
      const list = state.list.map((item) =>
        payload.ids.includes(item.id) ? { ...item, isActive: payload.state } : item,
      );
      return {
        ...state,
        list,
      };
    },
  },
};

export default ShortenedUrlsModel;
